import { gql } from "@apollo/client";

const SAVE_DATOS_CLINICOS_VISITA_CD = gql`
mutation CreateAndUpdateVisitaCD($input: AddVisitaCDInput!) {
  createAndUpdateVisitaCD(input: $input) {
    idVisitaCD
  }
}`;

export const adaptAddVisitaDatosClinicosCDInput = (data, alergiaOtrosId) => ({
  idVisitaCD: data?.idVisitaCD,
  idVisita: data?.idVisita,
  enfermedadOncologica: !!data?.enfermedadOncologica,
  peso: data?.peso,
  talla: data?.talla,
  soporteNutricional: !!data?.soporteNutricional,
  examenFisico: data?.examenFisico,
  traqueostomia: !!data?.traqueostomia,
  sondaVesical: !!data?.sondaVesical,
  ostomia: !!data?.ostomia,
  cateter: !!data?.cateter,
  sondaNasogastrica: !!data?.sondaNasogastrica,
  idComboVisitaValorKarnofsky: data?.idComboVisitaValorKarnofsky,
  idComboRIValorLansky: data?.idComboRIValorLansky,
  listaAlergia: data?.alergiasDatosClinicos?.map((id) => ({
    idAlergia: id,
    descripcionAlergiaOtro: id === alergiaOtrosId ? data?.descripcionAlergiaOtro : ''
  })) || [],
  listaDiagnostico: data?.diagnosticoCIE10?.map((diagnostico) => ({ idDiagnostico: diagnostico?.codigo, idItemDiagnostico: diagnostico?.codigoItem }))
});

export default SAVE_DATOS_CLINICOS_VISITA_CD;